import { LoggerProxy } from '../../logger/logger-proxy';
var DocumentDataParser = /** @class */ (function () {
    function DocumentDataParser() {
    }
    Object.defineProperty(DocumentDataParser, "parse", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (response) {
            var documentDataResponse;
            try {
                if (typeof response === 'string') {
                    documentDataResponse = JSON.parse(response);
                }
                else {
                    documentDataResponse = response;
                }
            }
            catch (error) {
                LoggerProxy.error('DocumentDataParser 文档数据解析异常, 错误信息 = ', error.message);
            }
            return documentDataResponse;
        }
    });
    return DocumentDataParser;
}());
export { DocumentDataParser };
